export default {
  getPopularCities: (state) => state.popularCities,
  getUrlKey: (state) => state.url_key,
  getCurrentCityName: (state) => state.city_name,
  getDomainLang: (state) => state.domain
}
